import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

// `blue` and `orange` are used as theme keys all over the views
// (color="blue", orange--text...), so they carry the brand palette too.
const brandBlue = '#1F5FBF'
const brandOrange = '#DF731C'

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: brandBlue,
        secondary: '#0F1B2D',
        accent: brandOrange,
        blue: brandBlue,
        orange: brandOrange,
        navy: '#0F1B2D',
        // Text-safe gold (4.6:1 on white) for focus rings and links on the sign-in pages.
        gold: '#A8651A',
        success: '#16A34A',
        error: '#DC2626',
        warning: '#D97706',
        info: '#0284C7'
      }
    }
  }
})
